import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumbs, { BreadcrumbsItem } from '../../../template/MainTheme/components/Breadcrumbs';
import { Society } from '../../../app/models/Society';
import { Client } from '../../../app/models/Client';
import useDispatchProgramService from '../../../app/services/hooks/useDispatchProgramService';
import {
    defaultDispatchProgramShowDataForm,
    DispatchProgram,
    DispatchProgramShowDataForm
} from '../../../app/models/DispatchProgram';
import LazyLoading from '../../../components/LazyLoading';
import DefaultCard from '../../../components/default/DefaultCard';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import DefaultCreatedModifiedUserForm from '../../../components/default/DefaultCreatedModifiedUserForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { toast } from 'react-toastify';
import DispatchProgramForm from '../components/forms/DispatchProgramForm';
import { TransportationOrderDataForm } from '../../../app/models/TransportationOrder';
import DispatchProgramShowForm from '../components/forms/DispatchProgramShowForm';
import DispatchProgramItemsContainer from '../components/DispatchProgramItemsContainer';
import { RouterParams } from '../../../app/shared/interfaces';
import { RunnerDataForm } from '../../../app/models/Runner';
import { AuthContext } from '../../../contexts/AuthContext';
import { Roles } from '../../../app/shared/enums';
import useSweetAlert from '../../../hooks/useSweetAlert';
import useNavigationPage from '../../../hooks/useNavigationPage';
import { AppContext } from '../../../contexts/AppContext';

const DispatchProgramEdit = () => {
    const { id } = useParams<RouterParams>();

    const { auth } = useContext(AuthContext);
    const { navigationPage } = useNavigationPage();

    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: 'Despachos',
            url: '/dispatch-programs',
            isActive: false
        },
        {
            name: 'Editar despacho #' + id,
            url: '/dispatch-programs/' + id + '/edit',
            isActive: true
        }
    ];

    const {
        editDispatchProgram,
        fetchingEditDispatchProgram,
        fetchingShowDispatchProgram,
        fetchingShowTransportationOrderDispatchProgram,
        updateDispatchProgram,
        showDispatchProgram,
        showTransportationOrderDispatchProgram
    } = useDispatchProgramService();

    const [dispatchProgramForm, setDispatchProgramForm] = useState<DispatchProgram>({
        contact_email: '',
        client_id: 0,
        society_id: 0
    });
    const [dispatchProgramShowDataForm, setDispatchProgramShowDataForm] =
        useState<DispatchProgramShowDataForm>(defaultDispatchProgramShowDataForm);

    const [errorFields, setErrorFields] = useState<any>();
    const [canBeEdited, setCanBeEdited] = useState(false);
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [transportationOrders, setTransportationOrders] = useState<TransportationOrderDataForm[]>(
        []
    );
    const [clients, setClients] = useState<Client[]>([]);
    const [societies, setSocieties] = useState<Society[]>([]);
    const [runners, setRunners] = useState<RunnerDataForm[]>([]);
    const [availableUse, setAvailableUse] = useState<boolean>(false);
    const [transportationSubOrderItemId, setTransportationSubOrderItemId] = useState<number>(0);
    const [isNotAuthorized, setIsNotAuthorized] = useState(false);

    useEffect(() => {
        reloadModule();
    }, []);

    const reloadModule = () => {
        edit(parseInt(id));
        // show(parseInt(id));
    };

    const edit = (id: number) => {
        setCanBeEdited(false);
        editDispatchProgram(id, {
            onSuccess: (response: ServiceResponse) => {
                setTransportationSubOrderItemId(
                    response.data.dispatch_program.transportation_order_item_id
                );
                if (
                    response.data.dispatch_program.transportation_order_id != '' ||
                    response.data.dispatch_program.transportation_order_id != null
                ) {
                    setCanBeEdited(true);
                }

                setSocieties(response.data.societies);
                setClients(response.data.clients);

                setTransportationOrders(response.data.transportation_orders);
                setRunners(response.data.runners);

                setDispatchProgramForm(response.data.dispatch_program);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message, {
                    autoClose: 2500
                });
                if (response.data.to_dashboard) {
                    navigationPage('/dispatch-programs');
                }
            }
        });
    };

    const show = (id: number) => {
        showDispatchProgram(id, {
            onSuccess: (response: ServiceResponse) => {
                setDispatchProgramShowDataForm(response.data.dispatch_program);
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando despacho...');
    
        updateDispatchProgram(dispatchProgramForm.id!, dispatchProgramForm, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
    
                toast.success(response.message);
                setErrorFields(undefined);
                reloadModule();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
    
                toast.error(response.message);
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
    
                setErrorFields(errorFields.data);
            }
        });
    };
    
    return (
        <>
            <Breadcrumbs pageSection={`Editar despacho #${id}`} breadcrumbs={breadcrumbs} />
            {isNotAuthorized ? (
                <div className="alert alert-danger">
                    No tienes permisos para editar este despacho
                </div>
            ) : (
                <>
                    <div className="row">
                        <div className="col-md-6">
                            <DefaultCard>
                                <div className="h3 mt-0 mb-2 card-title">Datos Generales</div>
                                {!fetchingEditDispatchProgram ? (
                                    canBeEdited ? (
                                        <>
                                            <DispatchProgramForm
                                                dispatchProgramForm={dispatchProgramForm}
                                                setDispatchProgramForm={setDispatchProgramForm}
                                                societies={societies}
                                                clients={clients}
                                                runners={runners}
                                                errorFields={errorFields}
                                                transportationOrders={transportationOrders}
                                                disabled={true}
                                                availableUse={availableUse}
                                            />
                                            <div className="row justify-content-end">
                                                <div className="col-auto">
                                                    <ButtonSaveForm callbackSave={update} />
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <DispatchProgramShowForm
                                            dispatchProgramShowDataForm={
                                                dispatchProgramShowDataForm
                                            }
                                            transportationOrder={null}
                                        />
                                    )
                                ) : (
                                    <LazyLoading />
                                )}
                            </DefaultCard>
                        </div>
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-body">
                                    <div className="h3 mt-0 mb-2 card-title">Usuarios</div>
                                    {!fetchingEditDispatchProgram ? (
                                        canBeEdited ? (
                                            <>
                                                <DefaultCreatedModifiedUserForm
                                                    createdBy={dispatchProgramForm.created_user}
                                                    createdAt={dispatchProgramForm.created_at}
                                                    updatedBy={
                                                        dispatchProgramForm.last_modified_user
                                                    }
                                                    updatedAt={dispatchProgramForm.updated_at}
                                                    status={dispatchProgramForm.status_selected?.name.toString()}
                                                />
                                            </>
                                        ) : (
                                            <DefaultCreatedModifiedUserForm
                                                createdBy={dispatchProgramShowDataForm.created_user}
                                                createdAt={dispatchProgramShowDataForm.created_at}
                                                updatedBy={
                                                    dispatchProgramShowDataForm.last_modified_user
                                                }
                                                updatedAt={dispatchProgramShowDataForm.updated_at}
                                                status={dispatchProgramForm.status_selected?.name.toString()}
                                                // status={dispatchProgramForm.status}
                                                // status={
                                                //      dispatchProgramShowDataForm.status_selected
                                                //          ? dispatchProgramShowDataForm.status_selected.name.toString()
                                                //          : ''
                                                //  }
                                            />
                                        )
                                    ) : (
                                        <LazyLoading />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {!fetchingEditDispatchProgram ? (
                        <>
                            <DispatchProgramItemsContainer
                                dispatchProgramId={parseInt(id)}
                                transportationSubOrderItemId={transportationSubOrderItemId}
                                canBeEdited={false}
                                reloadModule={reloadModule}
                                changeStatus={true}
                                // dispatchProgramForm={dispatchProgramForm}
                                // setDispatchProgramForm={setDispatchProgramForm}
                            />
                        </>
                    ) : null}
                </>
            )}
        </>
    );
};

export default DispatchProgramEdit;
